export default __webpack_public_path__ + "static/media/severance.51ab512d.svg";